import { type ReactNode } from 'react'

import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type IconType } from '@/defs/icon'
import { cn } from '@/utils/commonUtil'

import styles from './FeaturedComboHeading.module.scss'

type Props = {
  heading: ReactNode
  icon: IconType
  size?: 'sm'
  subheading?: ReactNode
}

export const FeaturedComboHeading = ({ heading, icon, size, subheading }: Props) => (
  <div className={cn(styles.container, { size, styles })}>
    <h2 className={styles.heading}>
      <IconWithLabel iconBefore={icon}>{heading}</IconWithLabel>
    </h2>
    {subheading && <p className={styles.subheading}>{subheading}</p>}
  </div>
)
